/**
 * WordPress dependencies
 */
import { SVG, Path } from '@wordpress/primitives';

const justifyStretch = (
	<SVG xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
		<Path d="M4 4H5.5V20H4V4ZM7 10L17 10V14L7 14V10ZM20 4H18.5V20H20V4Z" />
	</SVG>
);

export default justifyStretch;
